import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import {Button, FormControl} from "@mui/material";
import Dialog from "@mui/material/Dialog";
import React, {useEffect, useState} from "react";
import {useNavigate} from "react-router-dom";
import FormLabel from "@mui/material/FormLabel";
import RadioGroup from "@mui/material/RadioGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import Radio from "@mui/material/Radio";
import Box from "@mui/material/Box";
import {config} from "../../../constant";

export default function DialogDecision({open, onClose, categories, winnersByCategory, people, decisionsByCategory}) {
    // const { user, setUser } = useContext(UserContext);
    const [decisions, setDecisions] = useState([]);
    const navigate = useNavigate();

    useEffect(() => {
        setDecisions(categories.map(category => {
            const decision = decisionsByCategory[category.id];
            if (!decision) {
                return {
                    id: null,
                    nominated: {
                        id: null
                    },
                    category: {
                        id: category.id,
                        name: category.name
                    }
                };
            }
            return {
                id: decision.id,
                nominated: decision.nominated ? decision.nominated : {
                    id: -1
                },
                category: {
                    id: category.id,
                    name: category.name
                }
            };
        }));
    }, []);

    const save = () => {
        // Si le nominé est null, pas de décision, on ne sauvegarde pas.
        // Si le nominé est -1, tout le monde est sélectionné, on crée une décision avec un nominé null
        const decisionsToSave = decisions.filter(decision => decision.nominated.id !== null).map(decision => {
            return {
                id: decision.id,
                nominated: decision.nominated.id === -1 ? null : {
                    id: decision.nominated.id
                },
                category: {
                    id: decision.category.id
                }
            }
        });
        const requestOptions = {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(decisionsToSave)
        };
        fetch(`${config.BASE_URL}/decisions`, requestOptions)
            .then(response => {
                onClose();
                if (!response.ok) {
                    throw new Error(`${response.status} ${response.statusText}`)
                }
            }).catch(error => {
                const message = 'Erreur dans la sauvegarde des décisions';
                console.error(message, error);
                navigate("/error", {state: {message: message}});
            });
    };

    const handleDecisionChange = (event) => {
        const {
            target: { name, value }
        } = event;

        const categoryId = parseInt(name, 10);

        const nextDecisions = [...decisions];
        const decision = nextDecisions.find(decision => decision.category.id === categoryId);
        decision.nominated.id = parseInt(value, 10);
        setDecisions(nextDecisions);
    };

    return (
      <Dialog open={open} onClose={onClose} sx={{
          "& .MuiDialog-container": {
              "& .MuiPaper-root": {
                  width: "100%",
                  maxWidth: "300px",
              },
          },
      }}>
        <DialogTitle>Décisions</DialogTitle>
        <DialogContent>
            <form id="decisionForm" onSubmit={save}>
                {decisions && decisions.map((decision, index) => (
                    <FormControl key={decision.category.id} fullWidth sx={{marginTop: index === 0 ? 0 : '20px'}}>
                        <FormLabel id={decision.category.id}>{decision.category.name}</FormLabel>
                        <RadioGroup
                            aria-labelledby={decision.category.id}
                            name={decision.category.id.toString()}
                            value={decision.nominated.id}
                            onChange={handleDecisionChange}
                        >
                            {winnersByCategory[decision.category.id].map(winnerId => {
                                const winner = people.find(person => person.id === winnerId);
                                return <FormControlLabel key={winner.id} value={winner.id} control={<Radio />} label={winner.firstName} />;
                            })}
                            <FormControlLabel key={-1} value={-1} control={<Radio />} label="Tous" />
                        </RadioGroup>
                    </FormControl>
                ))}
            </form>
        </DialogContent>
        <DialogActions>
            <Button type="submit" form="decisionForm">OK</Button>
        </DialogActions>
      </Dialog>
    );
}
